<form nz-form [formGroup]="form">
    {{ this.msg1 }}
    <br />
    <br />
    <b>{{ this.msg2 }}</b>
    <br />
    <br />
    
    <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter your email!'">
            <input nz-input formControlName="email" placeholder="Email" required />
        </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter your password!'">
            <nz-input-group nzAddonBeforeIcon="lock">
                <input nz-input type="password" formControlName="password" placeholder="Password" required />
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>
</form>
  